<template>
  <section :class="{'border-top': topBorder, 'no-bottom-border': !bottomBorder}">
    <div class="left">
      <h2 v-if="sectionTitle">{{ sectionTitle }}</h2>
      <translation-language-selector
          :id="id"
          :allowed-languages="allowedLanguages"
          :selected-languages="selectedLanguages"
          :is-editable="!disabled"
          @input="onSelectedLanguageChange"
          ref="languageSelector"
      />
    </div>
    <div class="right" v-if="selectedLanguage">
      <div class="field_full" v-for="item in formSettings">
        <text-input
            v-if="item.type === 'text'"
            :id="id + '_'+item.name"
            :name="item.name"
            :ref="item.name + '_ref'"
            v-model="translationData[selectedLanguage][item.name]"
            :disabled="disabled || selectedLanguage == null"
            :help-text="item.hasOwnProperty('helpText') ? item.helpText : null"
            @change="onChange"
        >
          <span class="translate">{{ item.title }}</span> <span v-if="item.required">*</span>
        </text-input>

        <p v-if="item.type === 'html'" class="field">
          <html-editor
              :key="id + '_'+item.name"
              :id="id + '_'+item.name"
              :name="item.name"
              :ref="item.name + '_ref'"
              :body="translations[selectedLanguage][item.name]"
              @newVal="onHtmlChange(arguments[0], item.name)"
              :disabled="disabled || selectedLanguage == null"
          >
            <span class="translate">{{ item.title }}</span> <span v-if="item.required">*</span>
          </html-editor>
        </p>

        <span v-if="item.type === 'textarea'" class="translate">{{ item.title }}</span> <span v-if="item.required && item.type === 'textarea'">*</span>
        <textarea
            v-if="item.type === 'textarea'"
            :id="id + '_'+item.name"
            :name="item.name"
            :ref="item.name + '_ref'"
            v-model="translationData[selectedLanguage][item.name]"
            :disabled="disabled || selectedLanguage == null"
            :help-text="item.hasOwnProperty('helpText') ? item.helpText : null"
            @input="onChange"
            >
        </textarea>
        <p v-if="item.type === 'empty'"></p>
      </div>
    </div>
  </section>
</template>

<script>
import TranslationLanguageSelector from "./TranslationLanguageSelector.vue";
import HtmlEditor from "./HtmlEditor.vue";
import languages from "../mixins/languages";

export default {
  components: {HtmlEditor, TranslationLanguageSelector},
  mixins: [languages],
  props: {
    id: String,
    value: Object | Array,
    disabled: Boolean,
    formSettings: Array,
    sectionTitle: String,
    topBorder: Boolean,
    bottomBorder: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      selectedLanguage: null,
      translationData: {},
      dataLanguages: [],
      isInitialized: false,
    }
  },
  created() {
    this.updateDataObject();
  },
  computed: {
    translations: {
      get() {
        if (!this.translationData.hasOwnProperty(this.selectedLanguage)) {
          let data = {};
          this.formSettings.forEach((item) => {
            data[item.name] = null;
          })
          this.translationData[this.selectedLanguage] = data;
        }
        return this.translationData;
      },
    },
    allowedLanguages() {
      return [
          {value: 'ces', text: 'CES'},
          {value: 'eng', text: 'ENG'},
          {value: 'deu', text: 'DEU'},
          {value: 'slk', text: 'SLK'},
      ]
    },
    selectedLanguages() {
      let result = {};
      if (this.dataLanguages.length) {
        this.dataLanguages.forEach(item => {
          result[item] = true;
        });
      } else {
        let defaultLanguage = this.$store.getters.getLanguage;
        let language = defaultLanguage ? this.getIso3FromIso2(defaultLanguage) : 'ces';
        let index = 0;
          for (let key in this.allowedLanguages) {
            if (this.allowedLanguages[key].value == language) {
              index = key;
            }
          }
          if (this.allowedLanguages.length > 0) {
            result[this.allowedLanguages[index].value] = true;
          }
      }

      this.$nextTick(() =>{this.$refs['languageSelector'].setLanguageOptions()});
      return result;
    },
  },
  methods: {
    updateDataObject() {
      let result = {};
      this.allowedLanguages.forEach((item) => {
        let innerObject = {};
        this.formSettings.forEach((item) => {
          innerObject[item.name] = null;
        });
        result[item.value] = innerObject;
      });
      this.translationData = result;
    },
    onHtmlChange(newVal, name) {
      this.translationData[this.selectedLanguage][name] = newVal;
      this.onChange();
    },
    onChange() {
      let result = {};
      for (const [key, value] of Object.entries(this.selectedLanguages)) {
        if (value) {
          result[key] = this.translations[key];
        }
      }
      this.$emit('input', result);
    },
    onSelectedLanguageChange(selectedLanguage) {
      this.selectedLanguage = selectedLanguage;
    },
  },
  watch: {
    value(newVal) {
      if(!this.isInitialized) {
        this.translationData = {};
        this.dataLanguages = [];

        if (newVal && ((Array.isArray(newVal) && newVal.length > 0) || (typeof newVal === 'object' && Object.keys(newVal).length))) {
          this.allowedLanguages.forEach((item) => {
            if (newVal.hasOwnProperty(item.value)) {
              this.translationData[item.value] = newVal[item.value];
              this.dataLanguages.push(item.value);
            } else {
              let innerObject = {};
              this.formSettings.forEach((item) => {
                innerObject[item.name] = null;
              });
              this.translationData[item.value] = innerObject;
            }
          });
        } else {
          this.updateDataObject();
        }
        this.isInitialized = true;
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/common/TranslationFormPart.vue